module.exports = __webpack_public_path__ + "news-4a753f38/upload-a3282b78793010826cfdc2dc9eb81607.svg";